import { ReactNode, useCallback, useMemo, useState } from 'react';
import { createContext } from 'use-context-selector';
import { DashboardContextValues } from '@app/types/core/dashboard';

const DashboardContext = createContext<DashboardContextValues | null>(null);

interface DashboardProviderProps {
  children: ReactNode;
}

function DashboardProvider({ children }: DashboardProviderProps) {
  const [isNotificationOpened, setIsNotificationOpened] = useState(false);
  const [isHelpCenterOpened, setIsHelpCenterOpened] = useState(false);

  const toggleNotificationOpened = useCallback(() => {
    setIsNotificationOpened((prev) => !prev);
  }, []); // Empty deps - functional update doesn't need current state

  const toggleHelpCenterOpened = useCallback(() => {
    setIsHelpCenterOpened((prev) => !prev);
  }, []); // Empty deps - functional update doesn't need current state

  const value = useMemo(
    () => ({
      isNotificationOpened,
      setIsNotificationOpened,
      toggleNotificationOpened,
      isHelpCenterOpened,
      toggleHelpCenterOpened,
    }),
    [
      isNotificationOpened,
      isHelpCenterOpened,
      toggleNotificationOpened,
      toggleHelpCenterOpened,
    ]
  );

  return (
    <DashboardContext.Provider value={value}>
      {children}
    </DashboardContext.Provider>
  );
}

export { DashboardContext, DashboardProvider };
